import React from 'react';
import coffee from '../components/images/coffee-image.jpg';







function OrderHome () {
  return (
    <div style={styles.container}>
      {/* <h1 style={styles.containerText}>FLORAL.</h1>
      <p>1445 Floral Ave. New York City, United States</p> */}
      <ul style={styles.containerItems} >
        <li style={styles.containerText}>FLORAL.</li>
        <li style={styles.containerAddress}>1445 Floral Ave. New York City, United States</li>
      </ul>

      {/* <button style={styles.orderButton}>Order now</button> */}
    </div>
  );
}

export default OrderHome;

const styles = {
  container: {
    backgroundImage: `url(${coffee})`,
    width: '100%',
    paddingBottom: '13.9%',
    display: 'flex',
  },
  containerText: {
    fontSize: '10vw',
    fontFamily: "'Poppins', sans-serif",
    fontWeight: "Bold",
    fontWieght: 700,
    color: 'white',
    letterSpacing: '5px',
    paddingLeft: '18%',
  },
  containerItems: {
    listStyle: 'none',
    marginTop: '20%',
  },
  containerAddress: {
    paddingLeft: '24%',
    color: 'white',
  },

}